'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _actionTypes = require('../constants/actionTypes');

var initialState = (0, _immutable.Map)();

exports.default = (0, _reduxActions.handleAction)(_actionTypes.ADD_AVAILABILITY_MESSAGE_TIMEOUT, function (state, action) {
  var _action$payload = action.payload,
      channel = _action$payload.channel,
      timeout = _action$payload.timeout;


  return state.set(channel, timeout);
}, initialState);
module.exports = exports['default'];